import { enumBoxSubTypes, enumBoxType, enumMRBList } from "../constants";

export function GetMRBSubList(selectedBoxes, whichList) {
  var theList = [];
  var n = selectedBoxes.length;
  for (var i = 0; i < n; i++) {
    var b = selectedBoxes[i];
    var boxType = b.GetBoxType();
    if (whichList == enumMRBList.boxesOnly) {
      if (boxType == enumBoxType.standard) theList.push(b);
    } else if (b.GetContainerNode()) {
      theList.push(b.GetContainerNode().fChartBox);
    } // MRBOnly
    else {
      var subType = b.GetBoxSubType();
      if (boxType != enumBoxType.standard && subType == enumBoxSubTypes.refMRBox) theList.push(b);
    }
  }

  return theList;
}
